// Configure logging before any application modules are evaluated.
import './utils/productionConsole';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router  } from 'react-router-dom';
import App from './App';
//* Traductor
import LanguageProvider from './utils/LanguageProvider';
import { ServerProvider } from './context/ServerContext';
import './assets/css/index.css'

const root = ReactDOM.createRoot(document.getElementById('root'));
/* let servidor
fetch('/test.txt')                                  // usa ruta absoluta
      .then(response => response.text())
      .then(text => {
        servidor = text.trim()
        console.log('SERVIDOR actualizado:', servidor);
      })
      .catch(error => console.error('Error al obtener el Servidor:', error));
console.log('servidor',servidor) */
root.render(
    <ServerProvider>
  {/* <React.StrictMode> */}
      <Router style={{ cursor: 'default !important', userSelect: 'none', }}>
        <LanguageProvider>
          <App />
        </LanguageProvider>
      </Router>
  {/* </React.StrictMode> */}
    </ServerProvider>
);

